export const TOUR_STEP_IDS = {
  WORKSPACES_TABLE: 'workspaces-table',
  WORKSPACE_MENU_BUTTON: 'workspace-menu-button',
  WORKSPACE_MENU_POPOVER: 'workspace-menu-popover',
  WORKSPACE_STATUS_CELL: 'workspace-status-cell',
  WORKSPACES_TYPES_FILTER: 'workspaces-types-filter',
  WORKSPACES_SEARCH_BOX: 'workspaces-search-box',
  WORKSPACES_ADVERTISER_FILTER: 'workspaces-advertiser-filter',
  WORKSPACES_CREATED_BY_FILTER: 'workspaces-created-by-filter',
  NEW_WORKSPACE_TYPES_LIST: 'new-workspace-types-list',
  CREATE_WORKSPACE_BUTTON: 'create-workspace-button',
  CREATE_HCP_WORKSPACE_BUTTON: 'create-workspace-1',
  SAVE_WORKSPACE_DETAILS_BUTTON: 'save-workspace-details-button',
  SAVE_WORKSPACE_BUTTON: 'save-workspace-button',
  WORKSPACE_EDIT_BUTTON: 'workspace-edit-button',
  WORKSPACE_BACK_BUTTON: 'workspace-back-button',
  WORKSPACE_EXIT_BUTTON: 'workspace-exit-button',
  LOOKER_DASHBOARD: 'looker-dashboard',
  ADVERTISER_CONTROL: 'advertiser-control',
  WORKSPACE_NAME_CONTROL: 'workspace-name-control',
  WORKSPACE_LEFT_RAIL: 'workspace-left-rail',
  ADD_FILTERS_BUTTON: 'add-filters-button',
  NPI_GENDER_FILTER: 'gender_filter',
  PRESCRIPTIONS_FILTER: 'prescriptions_subgroup',
  NPI_GENDER_FILTER_UNKNOWN: 'npi-gender-filter-unknown',
  FILTERS_CONTAINER: 'filters-container',
  FILTERS_DRAWER: 'filters-drawer',
  CLINICAL_FILTERS: 'Clinical-filters-group',
  FILTER_HERO: 'filter-hero',
  FILTER_OK_BUTTON: 'filter-ok-button',
  FILTER_CLOSE_BUTTON: 'filter-close-button',
  AI_CONFIGURATOR_BUTTON: 'ai-configurator-button',
  AI_CONFIGURATOR_INPUT: 'ai-configurator-input',
  AI_CONFIGURATOR_BUILD_AUDIENCE_BUTTON: 'ai-configurator-build-audience-button',
  AI_CONFIGURATOR_TRY_ANOTHER_PROMPT: 'ai-configurator-try-another-prompt',
  HCP_WORKSPACE_ACTIONS_CONTAINER: 'hcp-workspace-actions-container',
  NPI_LIST_HEADER_BUTTON: 'npi-list-header-button',
  REPORTING_HEADER_BUTTON: 'reporting-header-button',
  WEBHOOK_HEADER_BUTTON: 'webhook-header-button',
  NPI_LIST_PULLOUT_MENU: 'npi-list-pullout-menu',
  REPORTING_PULLOUT_MENU: 'reporting-pullout-menu',
  NPI_LIST_PUBLISH_MENU_BUTTON: 'npi-list-publish-menu-button',
  NPI_LIST_PUBLISH_POPOVER: 'npi-list-publish-popover',
  NPI_LIST_PUBLISH_LIVE_LIST: 'npi-list-publish-live-list',
  NPI_LIST_PUBLISH_BUTTON: 'npi-list-publish-button',
  NPI_LIST_PUBLISH_LIFE_CHECKBOX: 'npi-list-publish-life-checkbox',
  REPORTING_DOWNLOAD_MENU_BUTTON: 'reporting-download-menu-button',
  REPORTING_SCHEDULE_MENU_BUTTON: 'reporting-schedule-menu-button',
  REPORTING_DOWNLOAD_POPOVER: 'reporting-download-popover',
  CLINICAL_RECENCY_FILTER: 'clinical-recency_filter',
  CLINICAL_DECILES_FILTER: 'clinical-deciles_filter',
  INCLUDE_EXCLUDE_FILTER_CONTAINER: 'include-exclude-filter-container',
  INCLUDE_EXCLUDE_FILTER_SEARCH: 'include-exclude-filter-search',
  FILTER_CANCEL_BUTTON: 'filter-cancel-button',
};
